import { useState } from "react";
import { createStyles, makeStyles } from "@mui/styles";

// components
import {
  Autocomplete,
  Grid,
  TextField,
  FormControl,
  IconButton,
} from "@mui/material";
import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";

const useStyles = makeStyles(() =>
  createStyles({
    actions: {
      display: "flex",
    },
    actionButton: {
      width: 36,
      height: 36,
      margin: "auto 0",
    },
  })
);

const PlanItemDish = (props) => {
  const {
    first,
    last,
    dish,
    dishes,
    units,
    onAddDish,
    onRemoveDish,
    onChange,
  } = props;

  const classes = useStyles();

  const [dishSelectOpen, setDishSelectOpen] = useState(false);

  const [dishId, setDishId] = useState(dish.id);
  const [dishAmount, setDishAmount] = useState(dish.amount);
  const [dishUnit, setDishUnit] = useState(dish.unit);

  const dishData = {
    id: dishId,
    amount: dishAmount,
    unit: dishUnit,
  };
  const dishValue = dishId > 0 ? { id: dishId } : null;

  const updateDish = (newData) => {
    onChange({
      ...dishData,
      ...newData,
    });
  };

  const canAdd = last;
  const canRemove = !last || (!first && last);

  const renderAutocompleteInput = (label, params) => {
    return (
      <TextField
        {...params}
        label={label}
        variant="standard"
        InputProps={{ ...params.InputProps }}
      />
    );
  };

  return (
    <>
      <Grid item sm={6} xs={12}>
        <Autocomplete
          open={dishSelectOpen}
          value={dishValue}
          options={dishes}
          onOpen={() => setDishSelectOpen(true)}
          onClose={() => setDishSelectOpen(false)}
          isOptionEqualToValue={(option, value) => {
            return parseInt(option.id) === parseInt(value.id);
          }}
          getOptionLabel={(option) => {
            const opt = dishes.find((dish) => {
              return parseInt(dish.id) === parseInt(option.id);
            });
            if (!opt) return "";

            return opt.name;
          }}
          onChange={(_, newVal) => {
            setDishId(newVal?.id);
            updateDish({ id: newVal?.id });
          }}
          renderInput={(params) => renderAutocompleteInput("Jelo", params)}
          disableClearable
        />
      </Grid>
      <Grid item sm={2} xs={4}>
        <TextField
          label="Količina:"
          type="number"
          value={dishAmount}
          variant="standard"
          onChange={(e) => {
            setDishAmount(e.target.value);
            updateDish({ amount: e.target.value });
          }}
        />
      </Grid>
      <Grid item sm={2} xs={6}>
        <FormControl fullWidth>
          <Autocomplete
            value={dishUnit ? { sign: dishUnit } : null}
            options={units}
            getOptionLabel={(option) => {
              const u = units.find((unit) => unit.sign === option.sign);
              if (!u) return "";

              return u.name;
            }}
            isOptionEqualToValue={(opt, val) => opt.sign === val.sign}
            onChange={(_, newVal) => {
              setDishUnit(newVal?.sign);
              updateDish({ unit: newVal?.sign });
            }}
            renderInput={(params) =>
              renderAutocompleteInput("Jed.Mere", params)
            }
          />
        </FormControl>
      </Grid>
      <Grid item sm={2} xs={2} className={classes.actions}>
        {canRemove && (
          <IconButton
            size="small"
            className={classes.actionButton}
            onClick={() => onRemoveDish(dish)}
            tabIndex={-1}
          >
            <RemoveIcon fontSize="small" />
          </IconButton>
        )}
        {canAdd && (
          <IconButton
            size="small"
            className={classes.actionButton}
            onClick={() => onAddDish()}
          >
            <AddIcon fontSize="small" />
          </IconButton>
        )}
      </Grid>
    </>
  );
};

export default PlanItemDish;
